import { Link } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";

const NotFound = () => {
  useSEO({
    title: "404 — Page Not Found",
    description: "This page could not be found on TaxShift 2026.",
    path: "/404",
  });

  return (
    <div className="py-24 md:py-40">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-4">
          Error · 404 · Lost briefing
        </p>
        <h1 className="font-heading text-7xl md:text-8xl font-bold tracking-tight mb-6" data-testid="not-found-title">
          Not <span className="italic text-primary">filed</span>.
        </h1>
        <p className="font-body text-lg text-foreground/80 mb-8">
          The page you were looking for doesn't exist at this URL. It may have been moved, or you
          followed a broken link.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="back-home"
            className="bg-primary text-primary-foreground font-mono uppercase tracking-widest text-xs px-8 py-4 hover:brightness-110 transition"
          >
            Back to Home
          </Link>
          <Link
            to="/calculators"
            data-testid="go-calculators"
            className="font-mono uppercase tracking-widest text-xs px-8 py-4 border-2 border-foreground hover:bg-foreground hover:text-background transition"
          >
            View Calculators
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
